import { useMutation } from "react-query";

import type { AppointmentV2, PostAppointmentV2Args } from "api/services/appointment/schemas/appointment_v2";
import { useApiClient } from "api/useApiClient";

export const usePostAppointmentV2 = () => {
  const client = useApiClient();

  return useMutation<AppointmentV2, Error, PostAppointmentV2Args>({
    mutationFn: args => client.postAppointmentV2(args),
  });
};
